import React from "react";
import {DisclaimerDiv} from "../Styled";
import CheckBox from "../../../HTMLEntities/CheckBox";
import Anchor from "../../../HTMLEntities/Anchor";
import {Field} from "react-final-form";
import {
    composeValidators,
    regRequiredValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import ToolTip from "../../../HTMLEntities/ToolTip";
import {pageTrackingData, trackClickEvent} from "../../../../utils/utils";
import {RootStore} from "../../../../configureStore";
import {useSelector} from "react-redux";
import {ABROAD_SIGN_UP_PROP_MAP} from "../../../../containers/RegistrationLoginPage/utils";
import {PageTrackingData} from "../../../CTA/types";
import config from "../../../../config/config";

const DisclaimerField: React.FC = () => {
    const isMobile = useSelector((state: RootStore) => state.layout.isMobile);
    const currentPage = useSelector((state: RootStore) => state.layout.currentPageName);
    const gaTrackingData = (pageTrackingData(
        isMobile,
        ABROAD_SIGN_UP_PROP_MAP,
        currentPage,
        "disclaimerFieldTracking",
    ) as PageTrackingData).disclaimerFieldTracking;

    const tooltipMsg = `I can edit my communication preferences at any time in "My profile" section and/or may withdraw and/or restrict my consent in full or in part`;

    let termsAndConditionMessage = {};
    console.log("config.SHIKSHA_STUDYABROAD_HOME", config.SHIKSHA_STUDYABROAD_HOME);
    termsAndConditionMessage = (
        <span>
            By continuing, you agree to our{" "}
            <Anchor
                linkHref={config.SHIKSHA_HOME + "/shikshaHelp/ShikshaHelp/privacyPolicy"}
                linkLabel="Privacy Policy"
            />{" "}
            and{" "}
            <Anchor
                linkHref={config.SHIKSHA_HOME + "/shikshaHelp/ShikshaHelp/termCondition"}
                linkLabel="Terms and Conditions"
            />
        </span>
    );

    if (!isMobile) {
        termsAndConditionMessage = (
            <span>
                I have read and provide consent for my data to be processed for purposes mentioned
                in the{" "}
                <Anchor
                    linkHref={config.SHIKSHA_HOME + "/shikshaHelp/ShikshaHelp/privacyPolicy"}
                    linkLabel="Privacy Policy"
                />{" "}
                and the{" "}
                <Anchor
                    linkHref={config.SHIKSHA_HOME + "/shikshaHelp/ShikshaHelp/termCondition"}
                    linkLabel="Terms and Conditions"
                />
                , and agree to be contacted for Education related services & promotions (you can
                edit your preference under My Profile)
            </span>
        );
    }

    return (
        <DisclaimerDiv>
            <Field
                name="termCondition"
                type="checkbox"
                validate={composeValidators(
                    regRequiredValidate("Please accept the Privacy Policy and T&C"),
                )}
                defaultValue={true}
            >
                {(props) => {
                    const onChange = props.input.onChange;
                    props.input.onChange = (change: React.ChangeEvent<HTMLInputElement>) => {
                        // GA TRACKING
                        if (!change.target.checked) {
                            trackClickEvent(
                                gaTrackingData.eventCategory,
                                gaTrackingData.eventAction ?? "",
                            );
                        }
                        onChange(change);
                    };
                    return (
                        <>
                            <CheckBox
                                id="termCondition"
                                inputRFF={props?.input}
                                error={props?.meta?.error as string}
                                isFocused={props?.meta?.active ?? false}
                                isError={props?.meta?.error && props?.meta?.touched}
                                errorDivStyle={{
                                    mobile: {top: "30px", left: "-5px"},
                                    laptop: {top: "30px", left: "-5px"},
                                }}
                            />

                            <label htmlFor="termCondition">
                                {termsAndConditionMessage}

                                <ToolTip tooltipLabel={tooltipMsg} id={"disclaimerTooltip"} />
                            </label>
                        </>
                    );
                }}
            </Field>
        </DisclaimerDiv>
    );
};

export default DisclaimerField;
